export default "/_next/static/sounds/tv_on_g3-63e6dabf3e85c1d394baed1ee23b8948.mp3";